/**
 * @module
 * @description Accessibility helpers for sitewide alert accordion: toggles aria-label between Expand/Collapse based on state.
 */

const initItem = (item) => {
	const details = item.querySelector('details');
	if (!details) return;

	const getTitle = () => {
		const btn = item.querySelector('.accordion-button');
		return (btn && btn.textContent ? btn.textContent : '').replace(/\s+/g, ' ').trim();
	};

	const setSummaryLabel = () => {
		const summary = details.querySelector('summary');
		if (!summary) return;

		const expanded = details.open;
		const title = getTitle();
		const suffix = title ? ` alert for ${title}` : '';
		summary.setAttribute('aria-label', (expanded ? 'Collapse' : 'Expand') + suffix);
	};

	setSummaryLabel();

	// Listen to toggle event on details element
	details.addEventListener('toggle', setSummaryLabel);
};

const sitewideText = () => {
	const items = document.querySelectorAll('.sitewide-text .accordion-item');
	if (!items.length) return;
	items.forEach(initItem);
};

export default sitewideText;
